// Using a more generic type for maximum flexibility and debugging purposes
interface PortfolioDebugInfoProps {
  portfolio: any | null;
}

export function PortfolioDebugInfo({ portfolio }: PortfolioDebugInfoProps) {
  // Disable debug info in all environments for now
  return null;
}

/* Original implementation - commented out to prevent debug info from showing
function OriginalPortfolioDebugInfo({ portfolio }: PortfolioDebugInfoProps) {
  if (!portfolio) return null;
  
  // Only render in development environment
  if (process.env.NODE_ENV !== 'development') return null;

  const allocations = portfolio.portfolio_allocations || [];
  
  return (
    <div className="border border-dashed border-gray-300 rounded-md p-4 mb-4 text-xs bg-gray-50">
      <h3 className="font-bold mb-2">Portfolio Debug Info</h3>
      <div>
        <strong>ID:</strong> {portfolio.id}
      </div>
      <div>
        <strong>Name:</strong> {portfolio.name}
      </div>
      <div>
        <strong>Allocations:</strong> {allocations?.length || 0}
      </div>
      {(allocations?.length || 0) > 0 && (
        <div className="mt-2">
          <strong>Allocation Details:</strong>
          <ul className="list-disc pl-4 mt-1">
            {(allocations || []).map((allocation: any) => (
              <li key={allocation.id} className="mt-1">
                <div>
                  ID: {allocation.id} 
                  {allocation.fund?.fund_name && (
                    <span className="font-medium"> - {allocation.fund.fund_name}</span>
                  )}
                </div>
                <div className="flex flex-wrap gap-2 text-[10px]">
                  <span>
                    Asset ID: {allocation.asset_id || 'N/A'}
                  </span>
                  <span>
                    Type: {allocation.asset_type || 'N/A'}
                  </span>
                  <span>
                    Percentage: {allocation.allocation_percentage}%
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
*/
